import { Pipe, PipeTransform } from '@angular/core';
import { DOCUMENT_TYPES } from '../constants';

@Pipe({
    name: 'roblexDocumentDescription',
})
export class DocumentDescriptionPipe implements PipeTransform {
    /**
     * Document types of document description pipe
     */
    documentTypes = DOCUMENT_TYPES;
    /**
     * Transforms document description pipe
     * @param {string} value
     * @returns string
     */
    transform(value: string): string {
        return this.documentTypes.find((item) => item.id === value)?.description ?? '';
    }
}
